import type {Chart} from 'chart.js';
import type {Context as ChartDataLabelsContext} from 'chartjs-plugin-datalabels';

/** Shared with bar end-label plugins — matches chartjs-plugin-datalabels `Context`. */
export function createBarChartLabelFormatterContext(chart: Chart<'bar'>, datasetIndex: number, dataIndex: number): ChartDataLabelsContext {
    const activeElements = chart.getActiveElements();
    const active = activeElements.some((el) => el.datasetIndex === datasetIndex && el.index === dataIndex);
    return {
        active,
        chart,
        dataIndex,
        dataset: chart.data.datasets[datasetIndex],
        datasetIndex,
    };
}
